import { Entity } from '@api/api/entity-schema';
import { useChartNavigate } from '@terminal/hooks/use-chart-navigate/useChartNavigate';
import { useNavigateToAssetOverview } from '@terminal/hooks/use-navigate-to-asset-overview/useNavigateToAssetOverview';
import { PosthogTrackingSource } from '@terminal/services/tracking/posthog/constants';
import { ChartSearchParamsAssetValue } from '@terminal/utils/chart-search-utils/chart-search-utils';
import { ChartState } from '@terminal/views/turbo-chart/hooks/use-chart-state/useChartState';

export const useAssetOverviewNavigation = (
  entity: Entity | undefined,
  source: PosthogTrackingSource,
  replace?: boolean
) => {
  const chartNavigate = useChartNavigate();
  const { navigateToPage } = useNavigateToAssetOverview();

  const navigateToAssetOverview = () => {
    if (!entity) return;
    navigateToPage({
      entityTag: entity.tag,
      source,
      replace,
    });
  };

  const navigateToChart = (chartState: ChartState) => {
    if (!entity) return;
    const entityValue: ChartSearchParamsAssetValue = [
      entity.tag,
      entity.default_snake,
      0,
    ];

    chartNavigate({
      assets: [entityValue],
      configParams: {
        resample: chartState.resample,
        horizon: chartState.horizon,
        seriesType: chartState.chartPanes[0].seriesType,
      },
      replace,
    });
  };

  return {
    navigateToAssetOverview,
    navigateToChart,
  };
};
